import React from 'react';
import { Navbar } from '../components/ui/NavBar';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HomeScreen } from '../components/home/HomeScreen';
import { AccountScreen } from '../components/account/AccountScreen';
import { LanguageScreen } from '../components/languages/LanguageScreen';
import CertificatesScreen from '../components/certificates/CertificatesScreen';
import { ProgressScreen } from '../components/progress/ProgressScreen';
import { InformationScreen } from '../components/information/InformationScreen';
import { UnitsScreen } from '../components/units/UnitsScreen';
import { CoursesScreen } from '../components/courses/CoursesScreen';
import { LessonsScreen } from '../components/lessons/LessonsScreen';
import { ChildScreen } from '../components/lessons/ChildScreen';
import { GChildScreen } from '../components/lessons/GChildScreen';
import { QuestionsScreen } from '../components/questions/QuestionsScreen';
import { QuestionScreen } from '../components/questions/QuestionScreen';
import { QuestionFail } from '../components/questions/QuestionFail';
import { QuestionOK } from '../components/questions/QuestionOK';
import { SponsorScreen } from '../components/sponsors/SponsorScreen';
import { FinishScreen } from '../components/finish/FinishScreen';

// DashboardRoute used to display Routes
export const DashboardRoutes = () => {


    return (
        <Routes>
            <Route path="/" element={ <HomeScreen/> } />
            <Route path="/home" element={ <HomeScreen/> } />
            <Route exact path="/account" element={ <AccountScreen/> } />
            <Route exact path="/languages" element={ <LanguageScreen/> } />
            <Route exact path="/certificates" element={ <CertificatesScreen/> } />
            <Route exact path="/progress" element={ <ProgressScreen/> } />
            <Route exact path="/information/:fatherId/:unitId/:questionId" element={ <InformationScreen/> } />
            <Route exact path="/course/:cursoId" element={ <CoursesScreen/> } />
            <Route exact path="/units/:cursoId" element={ <UnitsScreen/> } />
            <Route exact path="/lessons/:fatherId/:unitId" element={ <LessonsScreen/> } />
            <Route exact path="/child/:fatherId/:unitId" element={ <ChildScreen/> } />
            <Route exact path="/gchild/:fatherId/:unitId" element={ <GChildScreen/> } />
            <Route exact path="/questions/:chapterId" element={ <QuestionsScreen/> } />
            <Route exact path="/question/:fatherId/:unitId/:questionId" element={ <QuestionScreen/> } />
            <Route exact path="/question-fail/:fatherId/:unitId/:questionId" element={ <QuestionFail/> } />
            <Route exact path="/question-ok/:fatherId/:unitId/:questionId" element={ <QuestionOK/> } />
            <Route exact path="/sponsors" element={ <SponsorScreen/> } />
            <Route exact path="/finish/:cursoId" element={ <FinishScreen/> } />
            <Route element={<Navigate to="/home" />} />
        </Routes>
    )
}
